import { render, staticRenderFns } from "./PointPlanSubscriptionData.vue?vue&type=template&id=339a2021&scoped=true"
import script from "./PointPlanSubscriptionData.vue?vue&type=script&lang=js"
export * from "./PointPlanSubscriptionData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339a2021",
  null
  
)

export default component.exports